export default "__VITE_ASSET__43103117__"